import { message, Popconfirm, Switch, Table } from 'antd';
import axios from 'axios';
import { FilterIcon } from 'components/Filters/FilterIcon';
import { RangePickerFilter } from 'components/Filters/RangePickerFilter';
import { SumRange } from 'components/Filters/SumRange';
import {
  COLUMN_EXTRA_SMALL,
  COLUMN_MEDIUM,
  COLUMN_SMALL,
  PAGE_SIZE_OPTIONS,
  SCROLL_Y,
} from 'constants/table';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { checkValue } from 'utils';
import { priceRender, renderWithTooltip } from 'utils/table';

export const turnsTypeMap = {
  cash: 'Наличные',
  cashless: 'Безналичные',
  accruals: 'Начисления',
};

function ActSverkiTable({
  fetch,
  items,
  loading,
  current,
  pageSize,
  totalRows,
  filters = {},
  onRowClick,
  onFilter,
  onChange,
  isImport = false,
}) {
  const { f_sum, t_sum, start_date, end_date } = filters;
  const [changingStatus, setChangingStatus] = useState();

  const navigate = useNavigate();

  const handleReload = () => {
    navigate(0);
  };

  const updateRecord = async (id, status) => {
    try {
      const res = await axios.put(
        `org/v1/act-of-reconciliataion/${id}/status/`,
        {
          status,
        }
      );
      if (res) {
        message.success('Успешно обновлено');
      }
    } catch (error) {
      message.error('Произошла ошибка');
    }
  };

  const columns = [
    {
      width: COLUMN_EXTRA_SMALL,
      title: '№',
      dataIndex: 'id',
      key: 'id',
      render: checkValue,
    },
    {
      width: COLUMN_MEDIUM,
      title: 'Дата cоздания',
      dataIndex: 'created',
      key: 'created',
      filterDropdown: () => {
        return (
          <RangePickerFilter
            value={[start_date, end_date]}
            onFilterChange={([start, end]) => {
              onFilter({
                start_date: start,
                end_date: end,
              });
            }}
          />
        );
      },
      filterIcon: () => <FilterIcon isActive={start_date && end_date} />,
    },

    {
      width: COLUMN_MEDIUM,
      title: 'Контрагент',
      dataIndex: 'contractor_name',
      key: 'contractor_name',
      render: (name) => renderWithTooltip(name, 30),
    },
    {
      width: COLUMN_MEDIUM,
      title: 'БИН/ИИН контрагента',
      dataIndex: 'contractor_bin_iin',
      key: 'contractor_bin_iin',
      render: checkValue,
    },
    {
      width: COLUMN_MEDIUM,
      title: 'Сумма',
      dataIndex: 'saldo_end',
      key: 'saldo_end',
      render: priceRender,
      filterDropdown: () => {
        return (
          <SumRange
            fromValue={f_sum}
            toValue={t_sum}
            getRange={(first, second) =>
              onFilter({ f_sum: first, t_sum: second })
            }
          />
        );
      },
      filterIcon: () => <FilterIcon isActive={f_sum || t_sum} />,
    },
    {
      width: COLUMN_SMALL,
      title: 'Номер договора',
      dataIndex: 'number_contract',
      key: 'number_contract',
      render: checkValue,
    },
    {
      width: COLUMN_SMALL,
      title: 'Дата договора',
      dataIndex: 'date_contract',
      key: 'date_contract',
      render: checkValue,
    },
    {
      width: COLUMN_MEDIUM,
      title: 'Клиент',
      dataIndex: 'company_name',
      key: 'company_name',
      render: (name) => renderWithTooltip(name, 60),
    },
    {
      fixed: 'right',
      title: 'Акт согласован',
      dataIndex: 'approved',
      key: 'approved',
      width: COLUMN_SMALL,
      render: (approved, i) => {
        return (
          <Popconfirm
            title="Изменить согласованность акта
             сверки с контрагентом?"
            okText="Да"
            cancelText="Нет"
            onConfirm={() => {
              updateRecord(i.id, changingStatus);
              fetch();
            }}
            onCancel={() => {
              handleReload();
              fetch();
            }}
          >
            <Switch
              onChange={(e) => {
                setChangingStatus(e);
              }}
              defaultChecked={!!approved}
            />
          </Popconfirm>
        );
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ y: SCROLL_Y, x: !isImport ? 1300 : 1200 }}
      pagination={{
        current,
        total: totalRows,
        pageSize,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { ActSverkiTable };
